module.exports = __webpack_public_path__ + "static/media/omm.2658f3e9.jpg";